export default {
  'phoneSource.systemUser': '(System User)',
  'phoneSource.account': '(Account)',
  'phoneSource.contact': '(Contact)',
  'phoneSource.lead': '(Lead)',
  'phoneType.phone': '(Phone)',
  'phoneType.home': '(Home Phone)',
  'phoneType.business': '(Business Phone)',
  'phoneType.mobile': '(Mobile Phone)',
  'phoneType.unknown': '(Unknown Phone Type)',
  'phoneType.extension': '(Extension Phone)',
};
